import { render } from "./AlertMessage.vue?vue&type=template&id=70ab1592"
import script from "./AlertMessage.vue?vue&type=script&lang=js"
export * from "./AlertMessage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp320\\www\\vicra-lara\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Front/Reservations/AlertMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70ab1592"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70ab1592', __exports__)) {
    console.log('reload')
    api.reload('70ab1592', __exports__)
  }
  
  module.hot.accept("./AlertMessage.vue?vue&type=template&id=70ab1592", () => {
    console.log('re-render')
    api.rerender('70ab1592', render)
  })

}


export default __exports__